import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { AppComponent } from './iniciar-reclamacion.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule
  ],
  providers: [    
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/iniciar-reclamacion.module.ts